import { BASE_URL as _BASE } from '../Config';
const BASE_URL = (_BASE ?? '').replace(/\/+$/, '');

export const apiRequest = async (endpoint, method = 'GET', data = null, isFormData = false) => {
  try {
    let url = `${BASE_URL}${endpoint}`;
    const options = { method, headers: {} };

    // GET 요청 → 쿼리 변환
    if (method === 'GET' && data && !(data instanceof FormData)) {
      const query = new URLSearchParams(data).toString();
      url += `?${query}`;
    } else if (data) {
      // FormData 처리
      if (isFormData || data instanceof FormData) {
        options.body = data; // Content-Type 자동 설정됨
      } else {
        options.headers['Content-Type'] = 'application/json';
        options.body = JSON.stringify(data);
      }
    }

    const res = await fetch(url, options);
    if (!res.ok) throw new Error(`HTTP ${res.status} - ${await res.text()}`);

    return await res.json();
  } catch (err) {
    console.error(`API ${method} ${endpoint} 실패:`, err);
    throw err;
  }
};
